import RecentlyViewed from "./RecentlyViewed";

export * from "./RecentlyViewed";

export default RecentlyViewed;
